<div class="navigation" fxLayout="row" fxLayoutAlign="start center" vexContainer>
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>
